"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = (0, makeStyles_1.default)(() => ({
    labelLabel: {
        fontSize: 14,
        marginLeft: 5,
        '&.Mui-disabled': {
            color: 'inherit',
        },
    },
    labelRoot: {
        minHeight: 25,
        alignItems: 'flex-start',
    },
    checkboxControl: {
        margin: 0,
    },
    checkboxGroup: {
        display: 'flex',
        flexDirection: 'column',
    },
}));
//# sourceMappingURL=checkbox-group-styles.js.map